<template>
  <div>
    <div class="header z-depth-5 shadow-lg">
      <h3 class="font-weight-bold">
        Admin Login <br /><small
          >Please enter your username and password to login</small
        >
      </h3>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 d-none d-sm-block">
          <div class="text-center">
            <img src="@/assets/lock.png" class="img-fluid" />
          </div>
        </div>
        <div class="col-md-6 py-5">
          <form class="my-5" @submit.prevent="login">
            <div class="form-group mb-4">
              <label class="font-weight-bold">Username</label>
              <input
                type="text"
                class="form-control"
                value="Admin"
                disabled
                placeholder="Enter Username"
              />
            </div>
            <div class="form-group mb-4">
              <label class="font-weight-bold">Password</label>
              <input
                type="password"
                ref="password"
                class="form-control"
                placeholder="Enter Password"
              />
            </div>
            <div class="form-group mb-4">
              <button class="btn btn-primary btn-block">
                <span
                  v-if="loading"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                ></span
                >Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.header {
  background: #2950b2;
  color: #fff;
  padding: 40px 20px;
  text-align: center;
  font-weight: 900;
}
</style>

<script>
import axios from "axios";

export default {
  name: "Login",
  components: {},
  data() {
    return {
      loading: false,
      status: this.$route.params.status,
    };
  },
  methods: {
    login: function (e) {
      this.loading = true;
      let data = {
        // password: this.$refs.password.value,
        secret: this.$refs.password.value,
      };

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      this.$toast.open({
        message: "Processing : Please Wait...",
        type: "info",
      });
      axios
        .post(this.$apiURI + "/auth/admin/login", data, config)
        .then((response) => {
          if (response.data.error) {
            this.$toast.open({
              message: "Error : Invalid Login Details",
              type: "error",
            });
            this.loading = false;
          } else {
            this.$toast.open({
              message: "Login Successful",
              type: "success",
            });
            localStorage.clear();
            let fastAdminToken = response.data.data.token;
            let fastRole = response.data.data.role;
            // eslint-disable-next-line no-console

            localStorage.setItem("fastAdminToken", fastAdminToken);
            localStorage.setItem("fastRole", fastRole);
            window.location.href = "/dashboard";
            this.$router.push("/dashboard");
            e.target.reset();
          }
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          if (error.response) {
            this.$toast.open({
              message:
                "Error : " +
                (error.response.data.message == "Unauthenticated"
                  ? "Username or Password is Incorrect "
                  : error.response.data.message == "Unauthorized"
                  ? "Email not verified, Please check your email for a verification link and processes to activate your account"
                  : error.response.data.message),
              type: "error",
            });
          } else {
            this.$toast.open({
              message:
                "Network Error : Please check your internet connection, relaod this page and try again",
              type: "error",
            });
          }
          this.loading = false;
        });
    },
  },
};
</script>
